export default __webpack_public_path__ + "static/media/3.4d9b6138.jpg";